module.exports = __webpack_public_path__ + "media/assets/avia/search/passagers-d183e9e45bb3526c362f4beb80ec423a.png";